import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface CanonicalLinkProps {
  url?: string;
}

/**
 * Componente para gestionar enlaces canónicos
 * Ayuda a evitar problemas de contenido duplicado para SEO
 */
const CanonicalLink: React.FC<CanonicalLinkProps> = ({ url }) => {
  const location = useLocation();
  
  useEffect(() => {
    // Determinar la URL canónica
    const baseUrl = 'https://domired.top';
    const path = url || location.pathname;
    const canonicalUrl = `${baseUrl}${path}`;
    
    // Buscar si ya existe un enlace canónico
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    
    if (linkCanonical) {
      // Actualizar el enlace existente
      linkCanonical.setAttribute('href', canonicalUrl);
    } else {
      // Crear un nuevo enlace canónico
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      linkCanonical.setAttribute('href', canonicalUrl);
      document.head.appendChild(linkCanonical);
    }
    
    // Limpiar al desmontar
    return () => {
      // No eliminamos el enlace canónico al desmontar para evitar problemas con bots
    };
  }, [location.pathname, url]);
  
  // Este componente no renderiza nada visible
  return null;
};

export default CanonicalLink;
